module.exports = __webpack_public_path__ + "img/kayaking.c7ba93b8.svg";